module.exports = __webpack_public_path__ + "img/sensor-details-thumbnail.cf644e7c.png";